import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';

import { async } from '@angular/core/testing';
import { NguiScrollableModule } from '@ngui/scrollable';
import { scrollTo } from '@ngui/utils';
import { AuthService } from '../service/auth.service';
import { BudgetService } from '../service/budget.service';
import { CommonService } from '../service/common.service';
import { CompanyService } from '../service/company.service';
import { EnterpriseService } from '../service/enterprise.service';
import { HomeService } from '../service/home.service';
import { LoanService } from '../service/loan.service';
import { OperatingexpensesService } from '../service/operatingexpenses.service';
import { OtherService } from '../service/other.service';
import { ProjectService } from '../service/project.service';
import { ReportingService } from '../service/reporting.service';
import { ShareholderService } from '../service/shareholder.service';

@Component({
  selector: 'app-investorarchitect',
  templateUrl: './investorarchitect.component.html',
  styleUrls: ['./investorarchitect.component.css'],
})
export default class InvestorarchitectComponent implements OnInit {
  constructor(
    private operatingexpensesService: OperatingexpensesService,
    private shareholderService: ShareholderService,
    private otherService: OtherService,
    private loanService: LoanService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    private budgetService: BudgetService,
    private route: ActivatedRoute,
    private router: Router,
    vRef: ViewContainerRef,
    private toastr: ToastsManager,
    public fb: FormBuilder,
    private enterpriseService: EnterpriseService,
    private reportingService: ReportingService
  ) {
    this.toastr.setRootViewContainerRef(vRef);
    this.projectId = localStorage.getItem('projectId');
    this.companyId = localStorage.getItem('companyId');
    localStorage.removeItem('selected');
    this.showInstructions = false;
    this.getProjectData();
    this.getCompanyData();
    // this.getBudgetData();
    this.getShareholders();
    this.getLoansData();
    this.getOccupiedBedstenYearly();
    this.getAppraisalData();
    this.showAddLoanDiv = false;
    this.counter = 0;
    this.print = false;
    if (print) {
      this.getInvestors();
    }
  }

  id = 's1';

  hid = 'h1';

  wid = 'w1';

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() print: boolean;

  @Output() projectEmitInvestor: EventEmitter<any> = new EventEmitter();

  @Output() budgetEmitInvestor: EventEmitter<any> = new EventEmitter();

  @Output() loanEmitInvestor: EventEmitter<any> = new EventEmitter();

  @Output() shareholderEmitInvestor: EventEmitter<any> = new EventEmitter();

  @Output() opexEmitInvestor: EventEmitter<any> = new EventEmitter();

  @Output() appraisalEmitInvestor: EventEmitter<any> = new EventEmitter();

  // DECLARATION OF ALL VARIABLES
  projectId: string;

  companyId: string;

  projectName: string;

  companyLogoUrl = '';

  companyName: string;

  userid = '';

  purchasePrice = 0;

  totalSquareFeet = 0;

  ownerContrubution = 0;

  operatingCapital: number;

  operatingCapitalInt: number;

  maintenanceReserve: number;

  maintenanceReserveInt: number;

  capitalExpenditures: number = null;

  totalCapital: number = null;

  totalShare = 100;

  licensedBeds: number;

  vacanyFactor: number;

  occupancy: number;

  selectionType: string;

  bedRate: number;

  show: boolean;

  showBluePrint: boolean;

  showAddLoanDiv: boolean;

  newLoan = {};

  selected: boolean;

  profitSharePreferred = 0;

  profitShareExit = 0;

  lienPosition = '';

  personalGuarantee = '';

  investmentTitle = '';

  investmentName = '';

  loanAmount = 0;

  futureValue = 0;

  futureStartPoint = 0;

  interestRate = 0;

  term: number;

  monthlyPayment: any = 0;

  updateLoanId = '';

  counter = 0;

  totalProfit: number;

  payrollGOI: number;

  total_loan_investment: number;

  generalGOI: number;

  netProfitGOI: number;

  shareholder2_value: string;

  loanArray = [];

  selectedLoan = {};

  otherShareArray = [];

  shareholderArray = {
    shareholder1_name: '',
    shareholder2_name: '',
    shareholder3_name: '',
    shareholder4_name: '',
    shareholder1_value: '0%',
    shareholder2_value: '0%',
    shareholder3_value: '0%',
    shareholder4_value: '0%',
  };

  payrollGois = [];

  investors: string[] = new Array();

  investorsArray = [];

  noi_current: number;

  labels: string[] = [];

  start_up_month: Number;

  maintenance_reserve = '';

  maintenanceReserveContribution = '';

  reportData = {
    data: {
      equityAllocationArray: [],
    },
  };

  loanReportData = [];

  // DECLARATION OF OBJECT TO SHOW TEN YEARS DATA IN PRINTING AS WELL AS IN SCRENN
  parentObject: any = {
    labels: new Array(),
    qtrs: new Array(10),
    trs: new Array(),
    tables: new Array(1),
    equityAllocationArray: new Array(40),
  };

  showInstructions: boolean;

  ngOnInit() {
    this.totalfunds();
    // $('#main_header .title').append('<span>Investor Architect<sup>TM</sup></span>');
  }

  scrollTo(selector, parentSelector, horizontal) {
    scrollTo(
      selector, // scroll to this
      parentSelector, // scroll within (null if window scrolling)
      horizontal, // is it horizontal scrolling
      0 // distance from top or left
    );
    this.hid = selector.split('#').join('');
  }

  // GET SELECTED INVESTORS TO SHOW IN PRINTING FUNCTIONALITY ONLY
  getInvestors() {
    const self = this;
    this.investorsArray = [];
    this.investors = JSON.parse(localStorage.getItem('investors_id'));

    if (this.investors && this.investors.length > 0) {
      for (let i = 0; i < this.investors.length; i++) {
        this.loanService.getLoan(this.investors[i]).subscribe((loanData) => {
          this.investorsArray.push(loanData.data[0]);
        });
      }
      this.loanEmitInvestor.emit({ loanEmitFinancing: true });
    } else {
      this.loanService.getLoans(this.projectId).subscribe((loanData) => {
        for (let i = 0; i < loanData.data.length; i++) {
          this.investorsArray.push(loanData.data[i]);
        }
      });
    }
  }

  // GET SAVED PROJECT DATA FROM DB
  getProjectData() {
    this.projectService.getProject(this.projectId).subscribe(async (projectData) => {
      this.projectName = projectData.data[0].project_name;
      this.ownerContrubution = projectData.data[0].owner_contribution;
      this.licensedBeds = projectData.data[0].licensed_beds;
      this.operatingCapital = projectData.data[0].operating_capital;
      this.operatingCapitalInt = projectData.data[0].operating_capital;

      this.maintenanceReserve = projectData.data[0].maintenance_reserve;
      this.maintenanceReserveInt = projectData.data[0].maintenance_reserve;

      this.vacanyFactor = projectData.data[0].vacancy_factor;
      this.occupancy = 100 - this.vacanyFactor;
      this.selectionType = projectData.data[0].selection_type;
      if (this.selectionType === 'other') {
        this.bedRate = projectData.data[0].bed_rate_other;
      } else {
        this.bedRate = projectData.data[0].bed_rate;
      }
      this.lienPosition = projectData.data[0].lien_position;
      this.personalGuarantee = projectData.data[0].personal_guarantee;
      this.profitSharePreferred = projectData.data[0].profit_share_preferred;
      this.profitShareExit = projectData.data[0].profit_share_exit;
      this.maintenanceReserveContribution = projectData.data[0].maintenance_reserve_contribution;
      this.start_up_month = projectData.data[0].start_up_month;
      this.maintenance_reserve = projectData.data[0].maintenance_reserve;
      this.loanReportData = projectData.data[0].reportData;
      // GET ENTERPRISE APPRAISAL SAVED DATA FROM DB
      await this.getAppraisalData();

      // GET SAVED BUGDET DATA FROM DB
      await this.budgetService.getBudget(this.projectId).subscribe(async (budgetData) => {
        this.purchasePrice = budgetData.data[0].business_purchase_price;
        if (this.licensedBeds === null) {
          this.totalSquareFeet = 0;
        } else {
          this.totalSquareFeet /= this.licensedBeds;
        }
        const capitalExp =
          budgetData.data[0].total_capital -
          this.purchasePrice -
          budgetData.data[0].total_capitalAccountSubTotal;
        this.capitalExpenditures = isNaN(capitalExp) || capitalExp === null ? 0 : capitalExp;

        const acquisition_construction_renovation =
          budgetData.data[0].business_purchase_price +
          budgetData.data[0].total_realEstateSubTotal +
          budgetData.data[0].total_professionalSubTotal +
          budgetData.data[0].total_specialItemsSubTotal +
          budgetData.data[0].total_exteriorSubTotal +
          budgetData.data[0].total_interiorSubTotal;
        const data = {
          project_id: this.projectId,
          operatingCapital: this.operatingCapital,
          maintenanceReserve: this.maintenanceReserve,
          maintenanceReserveContribution: this.maintenanceReserveContribution,
          acquisition_construction_renovation,
          start_up_month: this.start_up_month,
          maintenance_reserve: this.maintenance_reserve,
        };
        // GET SAVED reporting DATA OF INTERMATH CAL FROM DB
        this.reportingService.fetchReportData(data).subscribe((res) => {
          this.reportData = res;

          this.parentObject.equityAllocationArray = this.reportData.data.equityAllocationArray;

          let equityAllocationValues = [];
          for (const sharePercentString of this.parentObject.labels.value) {
            equityAllocationValues = [];
            let sharePercent = null;
            if (sharePercentString !== null) {
              sharePercent = Number.parseFloat(sharePercentString);

              for (let j = 0; j < 40; j++) {
                const calculatedVal = Math.round(
                  (sharePercent * res.data.equityAllocationArray[j]) / 100
                );
                equityAllocationValues.push(calculatedVal);
              }
            }
            this.parentObject.trs.push(equityAllocationValues);
          }
        });
        await this.totalfunds();
      });
      // EMITTER IS USED TO EMIT EVENT WHEN ALL DATA IS LOADED IN CASE OF PRINTING ONLY
      this.projectEmitInvestor.emit({ projectEmitInvestor: true });
    });
  }

  // GET COMPANY DATA
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
      this.companyName = res.data[0].companyname;
      this.userid = res.data[0].userid;
    });
  }

  // GET APPRAISAL DATA
  getAppraisalData() {
    const data = { projectId: this.projectId };
    this.enterpriseService.getEnterpriseData(data).subscribe((res) => {
      this.noi_current = res.data[0].noi_current;
      this.totalSquareFeet = res.data[0].square_foot_future;
      // EMITTER IS USED TO EMIT EVENT WHEN ALL DATA IS LOADED IN CASE OF PRINTING ONLY
      this.appraisalEmitInvestor.emit({ appraisalEmitInvestor: true });
    });
  }

  // GET SAVED LOANS FROM DB
  getLoansData(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.loanService.getLoans(this.projectId).subscribe((loanData) => {
        // console.log(`[getLoansData] Loans: ${JSON.stringify(loanData.data, null, 2)}`);
        if (loanData.data.length === 0) {
          this.total_loan_investment = 0;
        } else {
          let totalAmount = 0;
          for (const loan of loanData.data) {
            totalAmount += +loan.loan_amount + +loan.additional_investment;
          }
          this.total_loan_investment = isNaN(totalAmount) ? 0 : totalAmount;
        }

        let selectedLoan = null;
        this.loanArray = loanData.data;
        const numLoans = this.loanArray.length;
        const loanId = localStorage.getItem('selected');
        if (loanId !== undefined && loanId !== null) {
          for (const loan of this.loanArray) {
            if (loanId === loan.loan_id) {
              // console.log(`Selected loan: ${loan.loan_id}`);
              selectedLoan = loan;
              break;
            }
          }
        }
        if (numLoans <= 0) {
          this.loanArray = [];
          this.show = false;
          this.showBluePrint = false;
        } else {
          if (!selectedLoan) {
            this.selectLoan(this.loanArray[0]);
          } else {
            this.selectLoan(selectedLoan);
          }
          this.show = true;
          this.showBluePrint = true;
          this.showAddLoanDiv = false;
        }
        // EMITTER IS USED TO EMIT EVENT WHEN ALL DATA IS LOADED IN CASE OF PRINTING ONLY
        this.loanEmitInvestor.emit({ loanEmitInvestor: true });
        resolve();
      });
    });
  }

  private convertValuetoPercent(value): string {
    if (typeof value === 'number') {
      return `${value}%`;
    }
    if (value.indexOf('%') === -1) {
      value += '%';
    }
    return value;
  }

  private formatShareholderValue(shareholderIndex: string) {
    this.shareholderArray[shareholderIndex] = this.convertValuetoPercent(
      this.shareholderArray[shareholderIndex]
    );
  }

  // GET SAVED SHAREHOLDERS DATA FROM DB
  getShareholders() {
    this.shareholderService.getShareholder(this.projectId).subscribe(async (res) => {
      this.shareholderArray = res.data[0];
      //
      // Ensure that all of the values have percentages because the display in the Equity Shares section is
      // directly out of the array, and later, we determine whether or not any of the 2-4 shareholders are
      // empty, which controls whether or not they are shown in the Equity Allocation Balances table.
      //
      this.formatShareholderValue('shareholder1_value');
      this.formatShareholderValue('shareholder2_value');
      this.formatShareholderValue('shareholder3_value');
      this.formatShareholderValue('shareholder4_value');
      await this.getOtherFields();
      await this.setParentObj();
      await this.shareholderEmitInvestor.emit({ shareholderEmitInvestor: true });
    });
  }
  // *************END OF GET TASKS ***********************//

  // Set Parent object for Investor table component
  setParentObj() {
    const self = this;
    //
    // The first shareholder is always the company itself. While it's probably best to use this.shareholderArray['shareholder1_name']
    // here, that assumes that the backend is returning the company name in that value (which is isn't as of v1.5.3), so we are just
    // going to override it to always be the company name here. (The bug in the backend manifests itself when the company name is
    // changed. The shareholder1_name isn't also getting updated.)
    //
    this.parentObject.labels.name = new Array(this.companyName);
    this.parentObject.labels.value = new Array(this.shareholderArray.shareholder1_value);

    //
    // Only add the other shareholders if the name isn't empty or the value is non-zero.
    //
    for (let shareholderNum = 2; shareholderNum <= 4; shareholderNum++) {
      const shareholderName = `shareholder${shareholderNum}_name`;
      const shareholderValue = `shareholder${shareholderNum}_value`;
      if (
        this.shareholderArray[shareholderName] !== '' ||
        this.shareholderArray[shareholderValue] !== '0%'
      ) {
        //
        // If a value was specified but a name wasn't, show the number and indicate that no name has been
        // provided yet.
        //
        let name = this.shareholderArray[shareholderName];
        if (name === undefined || name === null || name === '') {
          name = `${shareholderNum}: <UNNAMED>`;
        }
        this.parentObject.labels.name.push(name);

        //
        // Ensure that the value is always added as a string with a percent sign on the end. Sometimes, when just the
        // name is entered without a value, the default value of '0' is returned, and we want it displayed as '0%'.
        //
        let value = this.shareholderArray[shareholderValue].toString().trim();
        if (value.indexOf('%') === -1) {
          value += '%';
        }
        this.parentObject.labels.value.push(value);
      }
    }

    for (let i = 0; i < this.otherShareArray.length; i++) {
      this.parentObject.labels.name.push(this.otherShareArray[i].field_name);
      this.parentObject.labels.value.push(`${this.otherShareArray[i].field_value}%`);
    }
    this.parentObject.trs = new Array(2);
    if (this.print) {
      self.parentObject.tables = new Array(5);
    }
    self.parentObject.print = this.print;
  }

  // CALCULATE TOTALCAPITAL REQUIRED
  totalfunds() {
    this.purchasePrice = this.purchasePrice ? this.purchasePrice : 0;
    this.operatingCapital = this.operatingCapital ? this.operatingCapital : 0;
    this.capitalExpenditures = this.capitalExpenditures ? this.capitalExpenditures : 0;
    this.maintenanceReserve = this.maintenanceReserve ? this.maintenanceReserve : 0;
    this.ownerContrubution = this.ownerContrubution ? this.ownerContrubution : 0;
    this.totalCapital =
      +this.purchasePrice +
      +this.operatingCapital +
      +this.capitalExpenditures +
      +this.maintenanceReserve -
      this.ownerContrubution;
    this.totalCapital = this.totalCapital ? this.totalCapital : 0;
  }

  // UPDATE PROJECT PAGE DATA ONCHANGE
  onChange(event) {
    const fieldName = event.target.name;
    let value = this.replaceDollarsCommasPercentages(event.target.value);
    if (value === null || value === '') {
      value = 0;
    }
    if (fieldName === 'operatingCapital') {
      if (value === this.operatingCapitalInt) {
        return;
      }
      this.operatingCapitalInt = value;

      this.operatingCapital = value;
    } else if (fieldName === 'maintenanceReserve') {
      if (value === this.maintenanceReserveInt) {
        return;
      }
      this.maintenanceReserveInt = value;

      this.maintenanceReserve = value;
    }

    const data = { fieldName, value };
    this.projectService.onChangeProject(this.projectId, data).subscribe(
      (data) => {
        this.totalfunds();
      },
      (err) => {
        this.toastr.error(err.message, 'Error');
      }
    );
  }

  // ONCLICK TASKS
  // select loan for RAL Investor Blueprint
  selectLoan(loan) {
    localStorage.setItem('selected', loan.loan_id);
    this.showBluePrint = true;
    this.selectedLoan = loan;
    this.selectedLoan['selected'] = 1;
    this.selectedLoan['monthly_payment'] = Math.round(this.selectedLoan['monthly_payment']);
    this.selectedLoan['total_distributions'] = Math.round(this.selectedLoan['total_distributions']);
    this.selectedLoan['total_annualized_return'] = Number.parseFloat(
      this.selectedLoan['total_annualized_return']
    ).toFixed(1);
    this.totalProfit = +loan.interest_rate + +loan.future_value;
  }

  // LOAN TASKS
  // TO ADD A NEW ENTRY OF LOAN INTO DB
  addLoan() {
    const array = [];
    const data = { projectId: this.projectId, userId: this.userid };
    if (this.showAddLoanDiv === false) {
      this.showAddLoanDiv = true;
      this.showBluePrint = false;
      this.loanService.saveLoan(data).subscribe(
        (loanData) => {
          this.newLoan = loanData.data;
          if (loanData.messageId === 200) {
            // this.getLoansData();
          } else if (loanData.messageId === 400) {
            this.toastr.error(loanData.message, 'Error!');
          }
        },
        (err) => {
          this.toastr.error(err, 'Error!');
        }
      );
      // this.selectLoan(this.loanArray.lastIndexOf);
    } else {
      this.showAddLoanDiv = false;
      this.showBluePrint = true;
      this.removeLoan(this.newLoan, true);
    }
  }

  // EXECUTE WHEN CLEAR BUTTON OF LOAN CLICKED
  clear(loan, type) {
    // if type is loan then clear only above table
    // otherwise clear 2nd table
    const data = { loan, type };
    this.loanService.clearLoan(data).subscribe((res) => {
      this.getLoansData();
    });
  }

  // CALCULATE LOAN'S VALUES ON CLICKING CALCULATE BUTTON OF FIRST SECTION OF LOAN
  calculate(loan) {
    const formval = loan;
    this.updateLoanId = loan._id;
    const keyValue = [];
    keyValue[0] = 'loanAmount';
    keyValue[1] = 'interestRate';
    keyValue[2] = 'term';
    keyValue[3] = 'monthlyPayment';
    keyValue[4] = 'futureValue';

    const formValues = {};
    formval.loan_amount =
      formval.loan_amount === '' || isNaN(formval.loan_amount) ? null : formval.loan_amount;

    formval.interest_rate =
      formval.interest_rate === '' || isNaN(formval.interest_rate) ? null : formval.interest_rate;

    formval.monthly_payment =
      formval.monthly_payment === null || isNaN(formval.monthly_payment)
        ? null
        : formval.monthly_payment;

    formval.future_value =
      formval.future_value === null || isNaN(formval.future_value) ? null : formval.future_value;

    formValues['loanAmount'] = formval.loan_amount;
    formValues['interestRate'] = formval.interest_rate;
    formValues['term'] = formval.term !== '' ? formval.term : null;
    formValues['monthlyPayment'] = formval.monthly_payment;
    formValues['futureValue'] = formval.future_value;
    formValues['futureStartPoint'] =
      formval.future_start_point !== null ? formval.future_start_point : null;

    this.loanAmount = formval.loan_amount;
    this.interestRate = formval.interest_rate;
    this.term = formval.term !== '' ? formval.term : null;
    this.monthlyPayment = formval.monthly_payment;
    this.futureValue = formval.future_value;
    this.futureStartPoint =
      formval.future_start_point === null || isNaN(formval.future_start_point)
        ? null
        : formval.future_start_point;

    let j = 0;
    for (let i = 0; i <= 4; i++) {
      const val = formValues[keyValue[i]];
      if (val === null) {
        j++;
      }
    }
    // if(option_selected === 0){

    if (j !== 1) {
      this.toastr.error('Make sure exactly one of five variables is left blank, then  retry.');
      return;
    }
    if (formValues['interestRate'] !== null) {
      const totalAmount = formValues['loanAmount'] * (1 + formValues['interestRate'] / 100);
    }
    if (formValues['monthlyPayment'] === null) {
      const principal = formValues['loanAmount'];
      const interest = formValues['interestRate'] / 100 / 12;
      const payments = formValues['term'];
      const futureValue = formValues['futureValue'];
      const roi = Math.pow(1 + interest, -payments);
      const upperValue1 = futureValue * roi;
      const uppervalue2 = principal - upperValue1;
      const upperValue = uppervalue2 * (formValues['interestRate'] / 100);
      const lowerValue1 = 1 - roi;
      const lowerValue = 12 * lowerValue1;
      this.monthlyPayment = (upperValue / lowerValue).toFixed(2);
    } else if (formValues['term'] === null) {
      /* formValues['loanAmount'] = totalAmount - formValues['futureValue'];
        var termCalculated = formValues['loanAmount'] /formValues['monthlyPayment'];
        this.term = termCalculated; */

      const principal = formValues['loanAmount'];
      const rate = formValues['interestRate'];
      const mp = formValues['monthlyPayment'];
      const upperValue = mp / ((mp - principal) * rate);

      this.term = Math.log10(upperValue) / Math.log10(1 + rate);
    } else if (formValues['interestRate'] === null) {
      const period = 89;

      const financed = 78777;

      const rental = 67;
      const IRRval = [];

      IRRval.push(-financed);
      for (let i = 0; i < period; i++) {
        IRRval.push(rental);
      }
      const IRR = this.IRRCalc(IRRval, 0.001) * 0.01;
      const val = ((formValues['loanAmount'] - formValues['futureValue']) / formValues['loanAmount']) * 100;
      const interestRateCalculated = 100 - val;
      // var interestRateCalculated = Math.ceil(formValues['loanAmount']/ formValues['term']);
      this.interestRate = interestRateCalculated;
    } else if (formValues['loanAmount'] === null) {
      const futureValue = formValues['futureValue'];
      const interest = formValues['interestRate'] / 100 / 12;
      const payments = formValues['term'];
      const mp = formValues['monthlyPayment'];
      const roi = Math.pow(1 + interest, payments);

      const additionValue = (mp * (roi - 1)) / interest;

      this.loanAmount = Math.round((+futureValue + +additionValue) / roi);
    } else if (formValues['futureValue'] === null) {
      const monthlyPayment = formValues['monthlyPayment'];
      const interest = formValues['interestRate'] / 100 / 12;
      const payments = formValues['term'];
      this.futureValue = Math.round(
        formValues['loanAmount'] * Math.pow(1 + interest, payments) -
          (monthlyPayment * (Math.pow(1 + interest, payments) - 1)) / interest
      );
    }

    // }
    const loandata = {
      _id: this.updateLoanId,
      monthlyPayment: this.monthlyPayment,
      term: this.term,
      interestRate: this.interestRate,
      loanAmount: this.loanAmount,
      futureValue: this.futureValue,
      futureStartPoint: this.futureStartPoint,
      additional_investment: '', // formval.additional_investment,
      duration: formval.duration,
      profit_share_exit: formval.profit_share_exit,
      profit_share_preferred: formval.profit_share_preferred,
      project_id: formval.project_id,
      userId: this.userid,
      loan_id: formval.loan_id,
      investment_name: formval.investment_name,
    };

    this.loanService.saveLoanData(loandata).subscribe(
      (loanData) => {
        if (loanData.messageId === 200) {
          this.getLoansData();

          // save for debt service
          // let data = {'startUpMonth': formval.future_start_point,'term': this.term,'project_id': this.projectId,'monthlyPayment': this.monthlyPayment}
          const data = { project_id: this.projectId };
          this.projectService.saveDebt(data).subscribe();
        } else if (loanData.messageId === 400) {
          this.toastr.error(loanData.message, 'Error!');
        }
      },
      (err) => {
        this.toastr.error(err, 'Error!');
      }
    );
  }

  IRRCalc(CArray, guest) {
    const inc = 0.000001;
    let NPV;
    do {
      guest += inc;
      NPV = 0;
      for (let j = 0; j < CArray.length; j++) {
        NPV += CArray[j] / Math.pow(1 + guest, j);
      }
    } while (NPV > 0);
    return guest * 100;
  }

  // ADD MASKING TO ALL LOAN FIELDS WHILE ONCHANGE VALUE
  // addMasking(event,loan: any){
  //   var fieldName = event.target.name;
  //   if(fieldName === 'loanAmount'){
  //     if(loan.loan_amount === ''){
  //       loan.loan_amount = event.target.value;
  //     }else{
  //       loan.loan_amount = '$' + loan.loan_amount;
  //     }

  //   }else if(fieldName === 'interestRate'){
  //     if(loan.interest_rate === ''){
  //       loan.interest_rate = event.target.value;
  //     }else{
  //       loan.interest_rate = loan.interest_rate + '%';
  //     }

  //   }else if(fieldName === 'monthlyPayment'){
  //     if(loan.monthly_payment === ''){
  //       loan.monthly_payment = event.target.value;
  //     }else{
  //       loan.monthly_payment = '$' + loan.monthly_payment;
  //     }

  //   }else if(fieldName === 'futureValue'){
  //     if(loan.future_value === ''){
  //       loan.future_value = event.target.value;
  //     }else{
  //       loan.future_value = '$' + loan.future_value;
  //     }
  //   }else if(fieldName === 'futureStartPoint'){
  //     loan.future_start_point = loan.future_start_point;
  //   }
  //   return loan;

  // }

  // UPDATE LOAN'S INVETSMENT TITLE AND INVESTOR NAME WHILE ONCHANGE IN ORDER TO SAVE THEM IN DB
  onUpdate(loanId, event) {
    const { value } = event.target;
    const fieldName = event.target.name;
    const data = { fieldName, value };
    this.loanService.updateLoan(loanId, data).subscribe((res) => {
      if (res.messageId === 200) {
        if (fieldName === 'interestRate') {
          this.getLoansData();
        } else {
        }
      } else {
        this.toastr.error('Error while updating', 'Error!');
      }
    });
  }

  // TO DELETE LOAN ENTRY FROM DB WHEN CLIKED ON TRASH BUTTON OF LOAN
  removeLoan(loan: any, flag: boolean) {
    const loanName = loan.investment_name ? loan.investment_name : 'Loan';
    if (flag === true) {
      this.loanService.deleteLoan(loan.loan_id).subscribe((res) => {
        this.showAddLoanDiv = false;
        this.getLoansData();
        const data = { project_id: this.projectId };
        this.projectService.saveDebt(data).subscribe();
      });
    } else if (confirm('Are you sure you want to delete this loan/investment ?')) {
      this.loanService.deleteLoan(loan.loan_id).subscribe((res) => {
        this.showAddLoanDiv = false;
        this.getLoansData();
        const data = { project_id: this.projectId };
        this.projectService.saveDebt(data).subscribe();
      });
    }
  }

  // ************* END OF LOAN TASKS ***********/
  // ************ END OF ONCLICK TASKS ********/

  // TO UPDATE VALUES OF EQUITY SHAREHOLDERS ONCHANGE AND SAVE THEM INTO DB
  updateValue(event: any) {
    const value = `${event.target.value}%`;
    const fieldName = event.target.name;
    const data = { fieldName, value };
    this.shareholderService.updateShareholder(this.projectId, data).subscribe((res) => {
      if (res.messageId === 200) {
      } else if (res.messageId === 402) {
        this.toastr.error(res.message, 'Error!');
      }
      this.getShareholders();
      this.getProjectData();
    });
  }

  // GET SAVED TEN YEAR RECORD OF OPERATING EXPENSES FROM DB
  getOccupiedBedstenYearly() {
    const data = { projectId: this.projectId };
    const payrollTenYearsDataGoi = [];
    const generalTenYearsDataGoi = [];
    const opexTenYearsDataGoi = [];

    this.operatingexpensesService.tenYearsRecords(data).subscribe((res) => {
      for (let i = 0; i < res.data.length; i++) {
        payrollTenYearsDataGoi.push(res.data[i].total_payroll_year_goi);
        generalTenYearsDataGoi.push(res.data[i].total_general_year_goi);
        opexTenYearsDataGoi.push(res.data[i].total_opex_year_goi);
      }
      this.payrollGois.push(
        payrollTenYearsDataGoi[1],
        generalTenYearsDataGoi[1],
        opexTenYearsDataGoi[1]
      );

      this.payrollGOI = Math.round(payrollTenYearsDataGoi.reduce((a, b) => a + b, 0) / 10);
      this.generalGOI = Math.round(generalTenYearsDataGoi.reduce((a, b) => a + b, 0) / 10);
      this.netProfitGOI = Math.round(opexTenYearsDataGoi.reduce((a, b) => a + b, 0) / 10);
      this.opexEmitInvestor.emit({ opexEmitInvestor: true });
    });
  }

  // ########## OTHER FIELDS SECTION ###########//
  // ADD OTHER FIELDS
  addOtherField(parent, child) {
    const data = { projectId: this.projectId };
    let array = [];

    this.otherService.saveOtherField(parent, child, data).subscribe(
      () => {
        this.otherShareArray = [];
        this.getOtherFields().then(() => {
          if (child === 'share') {
            array = this.otherShareArray;
          }
          setTimeout(() => {
            document.getElementById(`label${child}${array.length - 1}`).focus();
          }, 100);
          // this.parentObject.trs = new Array(4+this.otherShareArray.length);
          // this.getShareholders();
          // this.getProjectData();
        });
      },
      (err) => this.toastr.error(err.message, 'Error!')
    );
  }

  // GET OTHER SAVED SHAREHOLDERS FROM DB
  getOtherFields(): Promise<Boolean> {
    const self = this;
    return new Promise((resolve, reject) => {
      self.otherService.getOtherFields(this.projectId, 'investor').subscribe((res) => {
        this.otherShareArray = [];
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].child === 'share') {
            this.otherShareArray.push(res.data[i]);
          }
        }
        resolve(true);
      });
    });
  }

  // REMOVE OTHER SAVED SHAREHOLDERS FROM DB WHEN CLICKED ON TRASH BUTTON
  removeOtherField(id) {
    let array = [];
    let companyShare = 0;
    const data = { id, parent: 'investor' };
    this.otherService.getFieldValue(id).subscribe((response) => {
      companyShare = +parseInt(
        this.shareholderArray.shareholder1_value.toString().split('%')[0] +
          +response.data[0].field_value,
        10
      );
      this.otherService.removeOtherField(data).subscribe((res) => {
        const event = { target: { value: companyShare, name: 'shareholder1_value' } };
        this.updateValue(event);
        this.getOtherFields().then((success) => {
          array = this.otherShareArray;
          setTimeout(function () {
            document.getElementById(`${'label' + 'share'}${array.length - 1}`).focus();
          }, 2000);
          this.parentObject.ts = new Array(this.otherShareArray.length);
        });
      });
    });
  }

  // CLEAR ARRAY OF OTHERFIELDS SHAREHOLDERS
  clearData() {
    this.otherShareArray = [];
  }

  // UPDATE VALUES OF SHAREHOLDERS OTHERFIELDS INTO DB ONCHANGE OF FIELDS
  updateFieldNameValue(id, event, field_name, nodeIndex) {
    const self = this;
    if (field_name === 'name') {
      const variableName = 'field_name';
      this.otherService
        .updateFieldNameValue(id, event.target.value, variableName)
        .subscribe((res) => {});
    } else {  // (field_name === 'value')
      const variableName = 'field_value';
      let variableValue = event.target.value;
      let companyShare = parseInt(
        this.shareholderArray.shareholder1_value.toString().split('%')[0],
        10
      );
      const previousValue = 0;
      let currentFieldPreviousValue = 0;
      let otherFieldsTotal = 0;
      // GET PREVIOUS VALUE OF THIS FIELD
      this.getOtherFields();

      // GET PREVIOUS VALUE OF THE FIELD WHICH IS BEING UPDATED AND TOTAL OF ALL OTHER FIELDS STARTS HERE
      for (let i = 0; i < this.otherShareArray.length; i++) {
        if (this.otherShareArray[i]._id === id) {
          currentFieldPreviousValue = this.otherShareArray[i].field_value; // .split('%')[0];
        }
        otherFieldsTotal += +this.otherShareArray[i].field_value; // .split('%')[0];
      }
      // GET PREVIOUS VALUE OF THE FIELD WHICH IS BEING UPDATED AND TOTAL OF ALL OTHER FIELDS ENDS HERE
      event.target.name = 'shareholder1_value';
      companyShare = +companyShare + +currentFieldPreviousValue - variableValue;

      event.target.value = companyShare; // +'%';
      if (companyShare > 0) {
        this.updateValue(event);
        variableValue = variableValue;
        this.otherService.updateFieldNameValue(id, variableValue, variableName).subscribe((res) => {
          this.clearData();
          this.getOtherFields().then((success) => {
            setTimeout(function () {
              if (nodeIndex < self.otherShareArray.length - 1) {
                document.getElementById(`label${nodeIndex + 1}`).focus();
              }
            }, 100);
          });
          this.setParentObj();
        });
      }
    }
    // this.getShareholders();
  }
  // ************* END OF OTHER FIELD TASKS ***************/

  // REMOVE , $ % . FROM THE INPUT ENTERED BY USER
  replaceDollarsCommasPercentages(value) {
    return value.replace(/[, $ %]+/g, '').trim();
  }

  // UPDATE INVESTMENT ESSENTIALS
  updateInvestment(event) {
    const value = this.replaceDollarsCommasPercentages(event.target.value);
    const fieldName = event.target.name;
    const data = { fieldName, value };

    this.projectService.updateInvetmentEssentials(this.projectId, data).subscribe((res) => {
      // console.log(res);
    });
  }

  // CALCULATE LOAN'S VALUES ON CLICKING CALCULATE BUTTON FOR SECOND SECTION OF LOAN
  changeThis(event, fieldName, loan) {
    if (loan.is_calculated === 1) {
      console.log(`Before updating: field: ${fieldName}, value: ${event.target.value}`);
      const value = this.replaceDollarsCommasPercentages(event.target.value);
      const data = {
        value,
        fieldName,
        project_id: this.projectId,
        loan,
        reportData: this.loanReportData,
      };
      this.loanService.updateProfitShares(data).subscribe((loanData) => {
        this.getLoansData();
      });
    } else {
      // console.log('io');
    }
  }

  // Open instructions in the nav bar when click on instructions button on header bar
  openModal() {
    this.showInstructions = !this.showInstructions;
  }

  // Close instructions in the nav bar when click on return button on header bar
  closeInstructions() {
    this.showInstructions = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/investorarchitect/investorarchitect.component.ts